<div class="modal-header">
  <h4 class="modal-title">{{ 'copyLimits.title' | transloco }}</h4>
  <button type="button" class="close" (click)="dismissModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="form-group">
    <label>{{ 'copyLimits.targetStore' | transloco }}</label>
    <div class="copy-limits__target">{{ targetStore?.title | uiLabel }}</div>
  </div>

  <div class="form-group">
    <label>{{ 'copyLimits.sourceStore' | transloco }}</label>
    <hx-store-select
      [default]="false"
      [filterFn]="filterStores"
      (selectChange)="onSourceStoreChanged($event)">
    </hx-store-select>
  </div>

  <div class="form-group">
    <label>{{ 'copyLimits.month' | transloco }}</label>
    <select class="form-control" [(ngModel)]="selectedMonthIndex">
      <option *ngFor="let month of monthOptions" [ngValue]="month.index">{{ month.title }} {{ selectedYear }}</option>
    </select>
  </div>

  <div class="form-group">
    <label>{{ 'copyLimits.strategy.label' | transloco }}</label>
    <div class="radio">
      <label>
        <input type="radio" name="operation" [(ngModel)]="operation" [value]="'APPLY_ALL'">
        {{ 'copyLimits.strategy.replaceAll' | transloco }}
      </label>
    </div>
    <div class="radio">
      <label>
        <input type="radio" name="operation" [(ngModel)]="operation" [value]="'APPLY_ALL_EXCEPT_EXIST'">
        {{ 'copyLimits.strategy.onlyMissing' | transloco }}
      </label>
    </div>
    <small class="text-muted d-block">{{ 'copyLimits.strategy.replaceAllHint' | transloco }}</small>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="dismissModal()">
    {{ 'copyLimits.cancel' | transloco }}
  </button>
  <button type="button" class="btn btn-primary" [disabled]="!sourceStoreId || isLoading.save" (click)="submit()">
    {{ 'copyLimits.submit' | transloco }}
  </button>
</div>
